<template functional>
	<span class="label"
		>{{ props.item.dynamicFieldName }}<span class="required ml6" v-if="props.item.config == 1">*</span></span
	>
</template>

<script>
export default {
	name: 'LabelField',
	functional: true,
	props: {
		item: {
			type: Object,
			required: true
		}
	}
};
</script>

<style lang="less" scoped>
.label {
	flex-shrink: 0;
	width: 0.83rem;
}
.ml6 {
	margin-left: 0.06rem;
}
.required {
	color: #eb5149;
	font-size: 0.15rem;
	font-weight: 400;
	vertical-align: middle;
}
</style>
